var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value_box"},[_c('div',{staticClass:"header"},[_vm._t("main")],2),_c('hr',{staticClass:"hr"}),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }